@if (id && baseRoute) {
<a [routerLink]="[baseRoute, id]" class="custom-link">
  {{ value || "-" }}
</a>
} @else {
<span>{{ value || "-" }}</span>
}
